import React from "react";
import "./styles.css";
import Anchor from "../anchor";

function PostCard({ title, description, image, link }) {
  return (
    <div className="post-card">
      <div className="post-card__content">
        <img src={image} alt="post preview" />
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <Anchor
        link={link}
        text={"Ver publicación"}
        background={"#109cf1"}
        color={"white"}
      />
    </div>
  );
}

export default PostCard;
